import { TextField, Box, Typography, ButtonBase } from '@mui/material';
import FieldWrapper from '../FieldWrapper';

export default function Step7Cittadinanza({ data, onChange, errors }) {
  const isExtraUE = data.cittadinanza === 'Altra' && data.cittadinanza_altra;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Cittadinanza
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Indica la tua nazionalità
        </Typography>
      </Box>

      <FieldWrapper label="Cittadinanza" required error={errors?.cittadinanza} completed={!!data.cittadinanza}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {['Italiana', 'Altra'].map(opt => (
            <ButtonBase
              key={opt}
              onClick={() => onChange('cittadinanza', opt)}
              sx={{
                flex: 1,
                py: 1.5,
                px: 2,
                borderRadius: 2,
                fontSize: '0.875rem',
                fontWeight: 500,
                border: '2px solid',
                transition: 'all 0.2s',
                borderColor: data.cittadinanza === opt ? 'primary.main' : 'divider',
                bgcolor: data.cittadinanza === opt ? 'primary.light' : 'transparent',
                color: data.cittadinanza === opt ? 'primary.main' : 'text.secondary',
                '&:hover': { borderColor: 'primary.main' }
              }}
            >
              {opt === 'Altra' ? 'Altra cittadinanza' : opt}
            </ButtonBase>
          ))}
        </Box>
      </FieldWrapper>

      {data.cittadinanza === 'Altra' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FieldWrapper label="Specifica la cittadinanza" required error={errors?.cittadinanza_altra} completed={!!data.cittadinanza_altra}>
            <TextField fullWidth size="small" value={data.cittadinanza_altra || ''} onChange={e => onChange('cittadinanza_altra', e.target.value)} placeholder="Es. Albanese, Rumena, Cinese..." />
          </FieldWrapper>

          <Box sx={{ p: 2, bgcolor: 'action.hover', borderRadius: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Per cittadini extra-UE</Typography>
              <Typography variant="caption" color="text.secondary">Se non sei cittadino UE, compila i seguenti campi</Typography>
            </Box>

            <FieldWrapper label="Scadenza permesso di soggiorno" error={errors?.scadenza_permesso_soggiorno} completed={!!data.scadenza_permesso_soggiorno}>
              <TextField fullWidth size="small" type="date" InputLabelProps={{ shrink: true }} value={data.scadenza_permesso_soggiorno || ''} onChange={e => onChange('scadenza_permesso_soggiorno', e.target.value)} />
            </FieldWrapper>

            <FieldWrapper label="In Italia dal (mese/anno)" error={errors?.soggiorno_dal} completed={!!data.soggiorno_dal} hint="Mese e anno di arrivo in Italia">
              <TextField fullWidth size="small" type="month" InputLabelProps={{ shrink: true }} value={data.soggiorno_dal || ''} onChange={e => onChange('soggiorno_dal', e.target.value)} />
            </FieldWrapper>
          </Box>
        </Box>
      )}
    </Box>
  );
}